import type { Timekeeper } from "@/features/attorney/views/Entries/timekeepers";
import type { Professional } from "./adminHelpers";

export function professionalToTimekeeper(
	professional: Professional,
): Timekeeper {
	const parts = professional.full_name.trim().split(/\s+/).filter(Boolean);
	const firstName = parts[0] ?? "";
	const lastName = parts.length > 1 ? parts.slice(1).join(" ") : firstName;
	return {
		id: professional.prof_id,
		firstName,
		lastName,
		fullName: professional.full_name,
		email: professional.email,
	};
}
